export default __webpack_public_path__ + "static/media/ChemistryTonic.b662720759c8e7708476763b0e4caf36.webp";